import { useMutation } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { operations } from "@/api/schema";

import { toOrder, type RawOrderListItem } from "../lib/order-list-vm";
import type { Order } from "../lib/types";

export interface ExportOrdersFilters {
  marketplace?: string;
  status?: string;
  seller_id?: string;
}

type ListOrdersQuery = NonNullable<operations["listOrders"]["parameters"]["query"]>;

/**
 * Fetch the orders matching the given API-supported filters and map them to the
 * view-model. The page generates the CSV client-side from this list — the async
 * server-side export job (`POST /v1/orders/export`) is a stub this phase.
 */
export function useExportOrders() {
  return useMutation({
    mutationFn: async (f: ExportOrdersFilters): Promise<Order[]> => {
      const query = {
        ...(f.marketplace && { marketplace: f.marketplace }),
        ...(f.status && { status: f.status }),
        ...(f.seller_id && { seller_id: f.seller_id }),
      } as ListOrdersQuery;

      const { data, error } = await apiClient.GET("/v1/orders", { params: { query } });
      if (error) throw error;
      return (data?.data ?? []).map((o) => toOrder(o as unknown as RawOrderListItem));
    },
  });
}
